import { StringSetConverter } from '@amzn/awscat-pattern-library-service-model';
import { JsonObject, JsonProperty } from 'json2typescript';
import constants from '../common/constants';
import FilterSelectionAttributes from './FilterSelectionAttributes';

interface TableSettingOption {
  visibleColumns?: string[];
  wrapLines?: boolean;
  stickyHeader?: boolean;
  pageSize?: number;
  filterSelectionAttributes?: FilterSelectionAttributes;
  clearFiltersOnRefresh?: boolean;
}
@JsonObject('TableSettingOptions')
class TableSettingOptions {
  public static create(options: TableSettingOption): TableSettingOptions {
    return Object.assign(new TableSettingOptions(), {
      filterSelectionAttributes: Object.assign(
        new FilterSelectionAttributes(),
        options.filterSelectionAttributes || {
          contentType: constants.TABLE_DEFAULT_CONTENT_TYPE,
          workflowState: constants.TABLE_DEFAULT_WORKFLOW_STATE,
        },
      ),
      pageSize: options.pageSize || constants.TABLE_DEFAULT_PAGE_SIZE,
      stickyHeader: options.stickyHeader || false,
      visibleColumns: new Set(options.visibleColumns || []),
      wrapLines: options.wrapLines || true,
      clearFiltersOnRefresh: options.clearFiltersOnRefresh || false,
    });
  }
  @JsonProperty('pageSize', Number, true)
  // @ts-expect-error TS2322 - strict migration
  pageSize: number = undefined;
  @JsonProperty('stickyHeader', Boolean, true)
  // @ts-expect-error TS2322 - strict migration
  stickyHeader: boolean = undefined;
  @JsonProperty('wrapLines', Boolean, true)
  // @ts-expect-error TS2322 - strict migration
  wrapLines: boolean = undefined;
  @JsonProperty('visibleColumns', StringSetConverter, true)
  // @ts-expect-error TS2322 - strict migration
  visibleColumns: Set<string> = undefined;
  @JsonProperty('filterSelectionAttributes', FilterSelectionAttributes, true)
  // @ts-expect-error TS2322 - strict migration
  filterSelectionAttributes: FilterSelectionAttributes = undefined;
  @JsonProperty('clearFiltersOnRefresh', Boolean, true)
  // @ts-expect-error TS2322 - strict migration
  clearFiltersOnRefresh: boolean = undefined;
}

export default TableSettingOptions;
